export default "__VITE_ASSET__DADmYGlj__"